"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var style_1 = require("../../../style");
var layout_1 = require("../../layout");
var DrawerFooter = function (_a) {
    var children = _a.children;
    return (react_1.jsx(layout_1.Flex, { gap: 12, css: {
            padding: '16px 24px',
            borderTop: "1px solid " + style_1.DesignSystemThemeColor.Gray.LIGHT_3,
            justifyContent: 'flex-end',
        } }, children));
};
exports.default = DrawerFooter;
